import React from 'react';
import * as C from "../componentsM/index"

const ConceptualLearning = () => {
    return (
        <>

            <C.Hero title={"CONCEPTUAL LEARNING"}
                image={"/hero/11.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p>Concepts have an essential place in the structure of knowledge. They require students to demonstrate levels of thinking that reach beyond facts or topics. Concepts are used to formulate the understandings that students should retain in the future; they become principles and generalizations that students can use to understand the world and to succeed in further study and in life beyond school.</p>


                    <p>The MYP curriculum at The International School aims to engage its students in enquiry based, conceptual learning to develop and deepen their understanding, so that they can use concepts to innovate, address challenges and solve problems.</p>

                    <p>MYP programme design uses two kinds of concepts:</p>

                    <p>Key concepts, contributed from each subject group, provide interdisciplinary breadth to the programme. Key concepts are powerful, abstract ideas that have many dimensions and definitions that have relevance within and across subjects and disciplines, providing connections that can transfer across time and culture. They have important interconnections and overlapping concerns. Key concepts engage students in higher-order thinking, helping them to connect facts and topics with more complex conceptual understanding.</p>


                    <p>Related concepts, grounded in specific disciplines, explore key concepts in greater detail, providing depth to the programme. They emerge from reflection on the nature of specific subjects and disciplines, providing a focus for enquiry into subject-specific content. Enquiry into related concepts helps students to develop more complex and sophisticated conceptual understanding.</p>


                    <p>Conceptual learning at The International School enables the successful completion of MYP eAssessments (from 2016), which can lead to IB MYP Course Results and contribute to the awarding of the IB MYP Certificate.</p>



                </div>
            </section>

        </>

    )
}

export default ConceptualLearning